/*
 *  I17TARIFC16Calcul.js
 *
 *  Created by Sébastien Hecart on 2018-08-05 14:44:59 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { I17TARIFC16_State } from '@batical/types/src'
//TODO IF REQUIREDimport {} from '@batical/types/src';
function I17TARIFC16_docalcul(state: I17TARIFC16_State) {
  state.invalidated = false
  //TODO CALCUL
  state.res_rendementElectReference = ((0.851 * state.in_partElecConso) / 100 + 0.888 * (1 - state.in_partElecConso / 100)) * 53.5
  state.res_rendThermiqueReference = 92
  state.res_ep =
    (1 -
      1 / (state.in_rendThermiqueModule / state.res_rendThermiqueReference + state.in_rendElecModule / state.res_rendementElectReference)) *
    100
  state.res_tarif = 54 + 1.26 * state.in_tarif + 130 * (state.res_ep / 100 - 0.1)
  return state
}

export default I17TARIFC16_docalcul
